/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetRulesetForStateRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {GetRulesetForStateResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const getRulesetForState = (request: GetRulesetForStateRequest, options?: CashRequestOptions) => post<GetRulesetForStateRequest, GetRulesetForStateResponse>("/proxy/services/squareup.timecards.TimeCalculationService/GetRulesetForState", request, {...options, rejectOnError: true })